module.exports = __webpack_public_path__ + "media/customizations/emberly/back-b31c1e4932d2cf17992724e3ef4cf292.jpg";